import * as React from "react";
import { forwardRef } from "react";
const SvgMissed = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { y: 0.859863, width: 24, height: 24, rx: 12, fill: "#EEEFF1" }), /* @__PURE__ */ React.createElement("path", { d: "M8 12.1932H16V13.5266H8V12.1932Z", fill: "#C3C3C3" }));
const ForwardRef = forwardRef(SvgMissed);
export default ForwardRef;
